import React, { useEffect, useState } from 'react'
import { api, getApiErrorMessage } from '../api'
import { Switch } from './ui'
import { useI18n } from '../i18n'

export default function PaidScriptSettingsPanel({ modelId }) {
  const { t } = useI18n()
  const [data, setData] = useState(null)
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const base = `/bot/models/${modelId}/paid-session-settings`
  async function request(options) {
    const response = await api(base, options)
    const body = await response.json()
    if (!response.ok) throw new Error(typeof body.detail === 'string' ? body.detail : t('paidScript.loadError'))
    return body
  }
  useEffect(() => {
    let live = true
    setData(null); setError('')
    request().then(value => { if (live) setData(value) }).catch(err => { if (live) setError(getApiErrorMessage(err, t('paidScript.loadError'))) })
    return () => { live = false }
  }, [base])

  async function toggle(enabled) {
    if (!data?.editable || busy) return
    if (!enabled && data.open_sessions > 0 && !window.confirm(t('paidScript.disableConfirm'))) return
    setBusy(true); setError('')
    try {
      setData(await request({ method: 'PATCH', body: JSON.stringify({ enabled, expected_enabled: data.enabled, expected_config_id: data.config_id }) }))
    } catch (err) {
      setError(getApiErrorMessage(err, t('paidScript.saveError')))
      try { setData(await request()) } catch { /* Retain last known state with error. */ }
    } finally { setBusy(false) }
  }
  return <section className="model-detail-paid-script-settings" style={{ padding: '12px', margin: '12px 0', minWidth: 0, border: '1px solid var(--border-color, #555)', borderRadius: '12px' }}>
    <strong>{t('paidScript.title')}</strong>
    {error ? <p role="alert">{error}</p> : null}
    {data ? <>
      <Switch checked={data.enabled} disabled={busy || !data.editable} onChange={toggle} label={t('paidScript.modelEnabled')} ariaLabel={t('paidScript.modelEnabled')} />
      <p className="model-edit-hint">{t('paidScript.modelHint')}</p>
      <small>{t('paidScript.configScope', { name: data.config_name || '—' })}</small>
      {!data.editable ? <p>{t('paidScript.sharedConfig')}</p> : null}
    </> : <p>{t('paidScript.loading')}</p>}
  </section>
}
